import React, { FC } from 'react'

import { Box } from '@material-ui/core'

import PageBanner from 'components/PageBanner'

const OnboardingView: FC = () => {

	return (
		<Box flex={1}>
			<PageBanner title="Onboarding" />
			Hello OnboardingView
		</Box>
	)
}

export default OnboardingView
